/* eslint no-prototype-builtins: "off" */

// adapted from:
// https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/before
// https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/after
// https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
//
// https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/append
// https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/prepend
//
// these were originally adapted from https://github.com/jserz/js_piece/ which no longer exists

// ChildNode mixin polyfills

(function (arr) {
  arr.forEach(function (item) {
    if (!item.hasOwnProperty('before')) {
      Object.defineProperty(item, 'before', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function before() {
          var argArr = Array.prototype.slice.call(arguments),
              docFrag = document.createDocumentFragment();

          argArr.forEach(function (argItem) {
            var isNode = argItem instanceof Node;
            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
          });

          this.parentNode.insertBefore(docFrag, this);
        }
      });
    }

    if (!item.hasOwnProperty('after')) {
      Object.defineProperty(item, 'after', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function after() {
          var argArr = Array.prototype.slice.call(arguments),
              docFrag = document.createDocumentFragment();

          argArr.forEach(function (argItem) {
            var isNode = argItem instanceof Node;
            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
          });

          this.parentNode.insertBefore(docFrag, this.nextSibling);
        }
      });
    }

    if (!item.hasOwnProperty('remove')) {
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          if (this.parentNode === null) {
            return;
          }
          this.parentNode.removeChild(this);
        }
      });
    }
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// ParentNode mixin polyfills

(function (arr) {
  arr.forEach(function (item) {
    if (!item.hasOwnProperty('append')) {
      Object.defineProperty(item, 'append', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function append() {
          var argArr = Array.prototype.slice.call(arguments),
              docFrag = document.createDocumentFragment();

          argArr.forEach(function (argItem) {
            var isNode = argItem instanceof Node;
            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
          });

          this.appendChild(docFrag);
        }
      });
    }

    if (!item.hasOwnProperty('prepend')) {
      Object.defineProperty(item, 'prepend', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function prepend() {
          var argArr = Array.prototype.slice.call(arguments),
              docFrag = document.createDocumentFragment();

          argArr.forEach(function (argItem) {
            var isNode = argItem instanceof Node;
            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
          });

          this.insertBefore(docFrag, this.firstChild);
        }
      });
    }
  });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

// matches and closest from
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector ||
                              Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}
